export class NativeStreamSchemaConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<NativeStreamSchemaColumn>",
            "format": ""
        },
        {
            "name": "newColumns",
            "baseName": "newColumns",
            "type": "NativeStreamNewColumnPolicy",
            "format": ""
        },
        {
            "name": "excludeColumns",
            "baseName": "excludeColumns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamSchemaConfig.attributeTypeMap;
    }
    constructor() {
    }
}
